export default "__VITE_ASSET__DcJcuRrR__"